import React, { Component } from "react";
import {
  profile,
  alert,
  float,
  toFixed,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  required,
  Select,
  BtnIcon,
  Pagination,
  Switch,
  Navbar,
  Modal,
  copyText,
  XLSX,
  saveAs,
  format_date,
} from "../../components/CustomComponent.js";
export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
modal_detail: false,

      filter_search: "",
      filter_broker_id: "",

      data: [],
      count: 0,
      data_broker: [],
      data_cfr: [],

      id: "",
      uid: "",
      broker_id: "",
      currency: "",
      customer_ref: "",
      name_th: "",
      name_en: "",
      email: "",
      deposit_fee_type: "",
      deposit_fee_value: 0,
      withdrawal_fee_type: "",
      withdrawal_fee_value: 0,
      is_vat: false,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      company_name: "",
      company_address: "",
      company_website: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      remark: "",
      callback_url: "",
      is_active: true,
      gateway_register: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
  }
  Get = async () => {
    loading(true);
    let result_broker = await GET("v1/admin/brokers/options", {
      page_size: 100000,
      page: 0,
      data_search: "",
    });
    if (result_broker?.status) {
      this.setState({
        data_broker: result_broker.data.map((e) => ({
          value: e.uid,
          label: e.name_en,
          gateway: e.gateway_deposits,
        })),
      });
    }
    loading(false);
  };
  GetCustomer = async () => {
    const { filter_broker_id } = this.state;
    if (!filter_broker_id) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    }
    let data, count;
    loading(true);
    let result = await GET("v1/admin/customers", {
      page_size: 100000,
      page: 0,
      data_search: "",
      currency: "THB",
      broker_id: filter_broker_id,
    });
    if (result?.status === true) {
      data = result.data;
      count = result.data.length;
    }
    this.setState({
      data,
      count,
    });
    loading(false);
  }; 
  chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  Verify = async () => { 
    const {data} = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", atob(global.cfr));
      myHeaders.append("Content-Type", "application/json");

      // 1️⃣ ดึง bank account ที่ checked
      // const accounts = data.filter(e => e.checked || e.is_blacklist);
      const accounts = data.filter(e => e.checked);

      // กันกรณีไม่มีข้อมูล
      if (accounts.length === 0) {
        alert("", "info", "No data", "No bank account selected");
        return;
      }

      console.log("accounts:",accounts)

      // 2️⃣ แบ่งเป็น chunk ละ 100
      const chunks = this.chunkArray(accounts, 100);

      // 3️⃣ สร้าง request promises
      const requests = chunks.map(chunk => {
        return fetch("https://cbl.tk9.us/v1/account/verify", {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ bank_account: chunk.map(e => e.bank_account_number) }),
          redirect: "follow"
        }).then(res => res.json());
      });

      // 4️⃣ ยิงพร้อมกันทั้งหมด
      try {
        const results = await Promise.all(requests);
        const hasFound = results.some(r => r?.status === "FOUND");
        const hasError = results.some(r => r?.error);
        if (hasFound) {

          // Update CFR
          const array = results.map(e=>e.results).flat();
          let data_customer = [];
          for(let item of accounts){
            if(item.is_blacklist){
              const check_cfr = array.find(e => e.bank_account === item.bank_account_number);
              console.log("check_cfr:",check_cfr)
              if(check_cfr){
                // เคส blacklist เก่า แต่ยังเจอ blacklist ใหม่อยู่
                data_customer.push({uid: item.uid, name: item.name_en || item.name_th || "-",bank_code:item.bank_code,bank_account_number:item.bank_account_number, risk_level: check_cfr.risk_level, risk_detail: check_cfr.notes, is_blacklist: true});
              }else{
                // เคส blacklist เก่า ไม่เจอ blacklist แล้ว
                data_customer.push({uid: item.uid, name: item.name_en || item.name_th || "-",bank_code:item.bank_code,bank_account_number:item.bank_account_number, risk_level: "-", risk_detail: "-", is_blacklist: false});
              }
            }else{
              const check_cfr = array.find(e => e.bank_account === item.bank_account_number);

              console.log("check_cfr:",check_cfr)
              if(check_cfr){
                // เคส blacklist ใหม่
                data_customer.push({uid: item.uid, name: item.name_en || item.name_th || "-",bank_code:item.bank_code,bank_account_number:item.bank_account_number, risk_level: check_cfr.risk_level, risk_detail: check_cfr.notes, is_blacklist: true});
              }
            }
          }
          console.log(data_customer);
          if(data_customer.length !== 0){
          let body = { data_list: data_customer.map(item => ({uid: item.uid,risk_level: item.risk_level, risk_detail: item.notes, is_blacklist: item.is_blacklist})) };
          let result = await POST("v1/admin/customers/bulk-update", body);
          if (result?.status === true) {
            this.setState({data_cfr: data_customer, modal_detail: true})
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again."
            );
          }
        }else{
           alert("", "info","Not found CFR","Not found transaction in CFR");
        }

        }else if(hasError){
           alert("", "error", "Error", "Network error occurred");
        return;
        } else {
          alert("", "info","Not found CFR","Not found transaction in CFR");
          return
        }
      } catch (err) {
        alert("", "error", "Error", "Network error occurred");
        return;
      }


      
      loading(false);
    }
  };
  ExportCSV = async (json_data) => {
      // 1. Convert JSON to worksheet
      const worksheet = XLSX.utils.json_to_sheet(json_data);

      // 2. Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CFR");

      // 3. Write the workbook to binary buffer
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // 4. Save to file
      const data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(
        data,
        `CFR${format_date(new Date(),"yyyy-mm-dd","en")}.xlsx`
      );
    
    loading(false);
  };
  render() {
    const { modal_detail, filter_search, filter_broker_id, data, count, data_broker, data_cfr } =
      this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3 position-relative">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Management</div>
                <div className="ar-title">CFR Accounts</div>
                <div className="ar-subtitle">Verify CFR Account</div>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
<span className="ms-auto ar-toolbar-hint">selected: {data.filter(e=>e.checked).length} | total: {count}</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field ar-filter-field-search">
<span className="ar-filter-label">Search</span>
<input
                type="text"
                className="form-control wpx-200"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Broker</span>
<Select
                  className="form-control"
                  placeholder="Broker..."
                  options={data_broker}
                  onChange={(e, i) => {
                    this.setState({ filter_broker_id: e },()=>{this.GetCustomer();});
                  }}
                  value={filter_broker_id}
                />
</div>
</div>
</div>
          </div>
          <div className="row mb-5 g-3">
            <div className="col-12 col-md-6">
              <div className="ar-table-card">
                <div className="ar-table-head"><div className="ar-table-title">All Customer</div></div>
            <div className="table-responsive" style={{maxHeight: "60vh"}}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-50 text-center cfr-accounts.update">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const newData = data.map((item) => {
                                return { ...item, checked };
                            });
                            this.setState({ data: newData });
                          }}
                          checked={data.every((item) => item.checked)}
                        />
                      </td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-center text-nowrap wpx-100">CFR</td>
                    <td className="text-center text-nowrap wpx-100">Level</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">UID</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                      const search = filter_search?.toLowerCase() || "";
                      const text = (
                        (item.name_en ?? "") +
                        (item.name_th ?? "") +
                        (item.bank_account_number ?? "")
                      ).toLowerCase();
                      if(!search || text.includes(search)){
                      return (
                    <tr key={`array-${index}`} className={item.checked ? "d-none" : ""}>
                      <td data-label={`Select`} className="text-center cfr-accounts.update">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              let _data = [...data];
                              _data[index].checked = e.target.checked;
                                this.setState({ data: _data });
                            }}
                            checked={item.checked}
                          />
                      </td>
                      <td data-label="Bank" className="text-nowrap text-start">
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div className="d-flex">
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2 mt-1"
                            />
                            <div>
                              <div style={{ height: 14 }}>{item.bank_code}</div>
                              <small className="text-secondary">
                                {item.bank_account_number || "-"}
                              </small>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td data-label="Status" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          {item.is_blacklist ? Status("blacklist", "dark") : Status("normal", "success")}
                        </div>
                      </td>
                      <td data-label="Status" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          {
                          item.risk_level === "LOW" ? Status("LOW", "warning") :
                          item.risk_level === "MEDIUM" ? Status("MEDIUM", "orange") :
                          item.risk_level === "HIGH" ? Status("HIGH", "danger") :
                          item.risk_level === "CRITICAL" ? Status("CRITICAL", "dark")  : null}
                        </div>
                      </td>
                      <td data-label="Customer" className="text-nowrap text-start">
                        <div>
                          <div style={{ height: 14 }}>
                            {item.name_en || item.name_th || "-"}
                          </div>
                          <small className="text-secondary">
                            {item.broker?.name_en ||
                              item.broker?.name_th ||
                              "-"}
                          </small>
                        </div>
                      </td>
                      <td data-label="UID" className="text-nowrap">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <div style={{ height: 14 }}>
                              {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                            </div>
                            <small className="text-secondary">
                              PayoutID:{" "}
                              {item.gateway_register.find((e) => e.uid)?.uid ||
                                "-"}
                            </small>
                          </div>
                          <span
                            className="icon pointer ms-2"
                            title="Copy"
                            onClick={() => {
                              copyText(item.uid || "");
                            }}
                          >
                            {"\uf0c5"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}else{return null}})}
                </tbody>
              </table>
            </div>
          </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="ar-table-card">
                <div className="ar-table-head"><div className="ar-table-title">Selected Customer</div></div>
            <div className="table-responsive" style={{maxHeight: "60vh"}}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-50 text-center cfr-accounts.update">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const newData = data.map((item) => {
                                return { ...item, checked };
                            });
                            this.setState({ data: newData });
                          }}
                          checked={data.every((item) => item.checked)}
                        />
                    </td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-center text-nowrap wpx-100">CFR</td>
                    <td className="text-center text-nowrap wpx-100">Level</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">UID</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={`array-${index}`} className={item.checked ? "" : "d-none"}>
                      <td data-label={`Select`} className="text-center cfr-accounts.update">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              let _data = [...data];
                              _data[index].checked = e.target.checked;
                                this.setState({ data: _data });
                            }}
                            checked={item.checked}
                          />
                      </td>
                      <td data-label="Bank" className="text-nowrap text-start">
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div className="d-flex">
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2 mt-1"
                            />
                            <div>
                              <div style={{ height: 14 }}>{item.bank_code}</div>
                              <small className="text-secondary">
                                {item.bank_account_number || "-"}
                              </small>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td data-label="Status" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          {item.is_blacklist ? Status("blacklist", "dark") : Status("normal", "success")}
                        </div>
                      </td>
                      <td data-label="Status" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          {
                          item.risk_level === "LOW" ? Status("LOW", "warning") :
                          item.risk_level === "MEDIUM" ? Status("MEDIUM", "orange") :
                          item.risk_level === "HIGH" ? Status("HIGH", "danger") :
                          item.risk_level === "CRITICAL" ? Status("CRITICAL", "dark")  : null}
                        </div>
                      </td>
                      <td data-label="Customer" className="text-nowrap text-start">
                        <div>
                          <div style={{ height: 14 }}>
                            {item.name_en || item.name_th || "-"}
                          </div>
                          <small className="text-secondary">
                            {item.broker?.name_en ||
                              item.broker?.name_th ||
                              "-"}
                          </small>
                        </div>
                      </td>
                      <td data-label="UID" className="text-nowrap">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <div style={{ height: 14 }}>
                              {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                            </div>
                            <small className="text-secondary">
                              PayoutID:{" "}
                              {item.gateway_register.find((e) => e.uid)?.uid ||
                                "-"}
                            </small>
                          </div>
                          <span
                            className="icon pointer ms-2"
                            title="Copy"
                            onClick={() => {
                              copyText(item.uid || "");
                            }}
                          >
                            {"\uf0c5"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
            </div>
          </div>
           {data?.some((e) => e.checked) && (
              <div className="w-100 px-3 py-2 d-flex justify-content-end bg-light position-fixed" style={{bottom:0, left: 0}}>
                <button className="ar-btn-gold cfr-accounts.update" onClick={this.Verify}>
                  Verify
                </button>
              </div>
            )}
        </div>
        <Modal
                  show={modal_detail}
                  onHide={() =>
                    this.setState({ modal_detail: false },()=>{window.localtion.reload()})
                  }
                  size={"xl"}
                  dialogClassName="pr-modal pr-scope pu-scope"
                >
                  <Modal.Header className="pr-modal-header" closeButton>
                    <div>
                      <div className="pr-modal-eyebrow">CFR</div>
                      <h5 className="fw-bold mb-0">
                        Detail CFR
                      </h5>
                    </div>
                  </Modal.Header>
                  <Modal.Body className="pr-modal-body pb-0">
                    <div className="table-responsive">
 <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-center text-nowrap wpx-100">CFR</td>
                    <td className="text-nowrap">Note</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">UID</td>
                  </tr>
                </thead>
                <tbody>
                  {data_cfr.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="Bank" className="text-nowrap text-start">
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div className="d-flex">
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2 mt-1"
                            />
                            <div>
                              <div style={{ height: 14 }}>{item.bank_code}</div>
                              <small className="text-secondary">
                                {item.bank_account_number || "-"}
                              </small>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td data-label="Status" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          {
                          item.risk_level === "LOW" ? Status("LOW", "warning") :
                          item.risk_level === "MEDIUM" ? Status("MEDIUM", "orange") :
                          item.risk_level === "HIGH" ? Status("HIGH", "danger") :
                          item.risk_level === "CRITICAL" ? Status("CRITICAL", "dark")  : null}
                        </div>
                      </td>
                      <td data-label="Note" className="text-nowrap text-start">
                        {item.risk_detail || "-"}
                      </td>
                      <td data-label="Customer" className="text-nowrap text-start">
                        {item.name}
                      </td>
                      <td data-label="UID" className="text-nowrap">
                        <div className="d-flex justify-content-between align-items-center">
                          {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                          <span
                            className="icon pointer ms-2"
                            title="Copy"
                            onClick={() => {
                              copyText(item.uid || "");
                            }}
                          >
                            {"\uf0c5"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              <div className="d-flex justify-content-center mb-3">
                <button className="ar-btn-gold px-4 mx-1" onClick={() => {
                              copyText(JSON.stringify(data_cfr.map(item=>({
                                UID: item.uid,
                                Customer: item.name,
                                Bank: `${item.bank_account_number} (${global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.value})`,
                                CFR: item.risk_level,
                                Note: item.risk_detail
                              })),null,2));
                            }}>Copy</button>
                <button className="ar-btn-gold px-4 mx-1" onClick={() => { this.ExportCSV(data_cfr.map(item=>({
                                Customer: item.name,
                                Bank: `${item.bank_account_number} (${global.bank.find((b) => b.value === item.bank_code)?.value})`,
                                CFR: item.risk_level,
                                Note: item.risk_detail
                              })))}}>ExportCSV</button>
              </div>
                  </Modal.Body>
                </Modal>
      </div>
    );
  }
}
